import React, { useState } from 'react';
import { Drawer, Tabs } from 'antd';
import { GeneratePaymentForm } from '../GeneratePaymentForm';
import { GenerateServicePaymentForm } from '../GenerateServicePaymentForm';

function ExposePaymentDrawer({
  isActive,
  clients,
  clientId,
  packages,
  packagesLoading,
  onClose,
  onSuccess,
}) {
  const [activeTab, setActiveTab] = useState('tax');
  const drawerTitle =
    activeTab === 'tax' ? 'Новый платеж на налоги' : 'Новый платеж на услуги';

  return (
    <Drawer
      title={drawerTitle}
      width="70%"
      onClose={onClose}
      visible={isActive}
      getContainer={false}
    >
      <Tabs
        centered
        activeKey={activeTab}
        onChange={(tab) => setActiveTab(tab)}
      >
        <Tabs.TabPane tab="Налоги" key="tax">
          <GeneratePaymentForm
            clientId={clientId}
            clients={clients}
            onSuccess={onSuccess}
          />
        </Tabs.TabPane>

        <Tabs.TabPane tab="Услуги" key="service">
          <GenerateServicePaymentForm
            clientId={clientId}
            packages={packages}
            packagesLoading={packagesLoading}
            onSuccess={onSuccess}
          />
        </Tabs.TabPane>
      </Tabs>
    </Drawer>
  );
}

export { ExposePaymentDrawer };
